module.exports = __webpack_public_path__ + "static/media/Backstage.0cd64672.webp";